/**
 * Texto del tamaño de equipo de un plan.
 *
 * Vive acá y no en cada pantalla porque lo pintan tres sitios —la tabla del
 * administrador, la página pública de precios y el bloque de pago— y la
 * redacción tiene que ser la misma en los tres: si la landing dice «1 a 5
 * usuarios» y el administrador «1-5», el mismo dato parece dos cosas.
 *
 * Devuelve `null` cuando el plan no declara rango (Personalizado), que es
 * justamente el que se define a la medida.
 */
export function rangoUsuarios(
  plan: { minUsers?: number | null; maxUsers?: number | null },
): string | null {
  const { minUsers: min, maxUsers: max } = plan;
  if (min == null && max == null) return null;
  if (min != null && max != null) return min === max ? `${min}` : `${min} a ${max}`;
  return min != null ? `${min} o más` : `hasta ${max}`;
}

/** Lo mismo, ya con la palabra: «1 a 5 usuarios». */
export function textoUsuarios(
  plan: { minUsers?: number | null; maxUsers?: number | null },
): string | null {
  const r = rangoUsuarios(plan);
  if (!r) return null;
  return `${r} ${r === "1" ? "usuario" : "usuarios"}`;
}
